<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-66">
			<form ref="absence_add" @submit.prevent="addAbsence">
				<md-card class="card-table">
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="md-layout">
							<div class="md-layout-item">
								<div class="card-icon">
									<md-icon>add</md-icon>
								</div>
								<h4 class="title">Ajouter une absence</h4>
							</div>
						</div>
					</md-card-header>
					<absence-form :absence="absence" :errors="errors"></absence-form>
					<md-card-actions md-alignment="left">
						<md-button class="md-success" type="submit">Ajouter</md-button>
						<md-button class="md-warning" @click="goBack">Retour</md-button>
					</md-card-actions>
				</md-card>
			</form>
		</div>
	</div>
</template>

<script>
import AbsenceForm from "@/pages/Technicians/Absences/components/AbsenceForm";

export default {
	name: "AbsenceAdd",
	components: {
		AbsenceForm
	},
	data() {
		return {
			absence: {
				idAbsenceType: null,
				idTechnician: null,
				dayNumber: null,
				start: this.$moment().format(),
				end: null,
				comment: null,
				isArchived: false,
			},
			errors: []
		}
	},
	methods: {
		async addAbsence() {
			this.errors = []
			try {
				await this.$store.dispatch('absences/addAbsence', {
					technician_id: this.absence.idTechnician,
					absence_type_id: this.absence.idAbsenceType,
					date_start: this.$moment(this.absence.start).format(),
					date_end: this.absence.end ? this.$moment(this.absence.end).format() : null,
					day_number: this.absence.dayNumber,
					comment: this.absence.comment,
					is_archived: this.absence.isArchived
				})
				await this.$store.dispatch('alerts/success', 'Absence ajoutée')
				this.goBack()
			} catch (e) {
				this.errors = e.response.data.errors
			}
		},
		goBack() {
			this.$router.back()
		}
	}
}
</script>

<style scoped>

</style>
